<!--
 * @Author: Axs <i@axs.email>
 * @Date: 2022-07-01 17:02:20
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-07-13 10:29:18
 * @Description: 
 * @FilePath: /src/page/coupon/select.vue
-->
<template>
    <div class="page page-coupon-select">
        <div class="coupon-list">
            <div
                class="coupon-item"
                :class="[
                    { select: item.selected },
                    { 'no-select': currentSelectSeatsCount + item.useSeatCount > seatsCount },
                    { 'no-select': cardType != 0 && item.type != cardType },
                    { 'hide-price': item.hidePriceBlock },
                    { 'no-use': item.cannotUseReason },
                ]"
                @click="clickItem(item)"
                v-for="(item, index) in couponList"
                :key="index"
            >
                <div class="price-box">
                    <div class="price">{{ item.cardAmount }}</div>
                    <div class="price-desc">{{ item.cardAvailableAmountDesc }}</div>
                </div>
                <div class="name">
                    <div class="tip">{{ item.typeDesc }}</div>
                    {{ item.cardName }}
                </div>
                <div class="time">有效期至 {{ item.availableEndTimeDesc }}</div>
                <div class="reason" v-if="item.cannotUseReason">{{ item.cannotUseReason }}</div>
                <div class="status"></div>
            </div>
        </div>
        <div class="no-list" v-if="couponList.length == 0">
            <img src="~@/assets/images/image-no-info.png" class="image" />
            <div class="tip">暂无信息</div>
        </div>
        <div class="footer" v-if="couponList.length">
            <div class="title">
                已选{{ currentSelectCouponCount }}张，可减
                <span class="span">¥{{ currentSelectSeatsPrice }}</span>
            </div>
            <div class="btn" @click="submit">确定</div>
        </div>
    </div>
</template>
<style lang="less" scoped>
@import url('~@/lib/base');
.page-coupon-select {
    min-height: 100vh;
    box-sizing: border-box;
    .coupon-list {
        .coupon-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: .pxToRem(690) [];
            height: .pxToRem(180) [];
            background: #ffffff;
            box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] .pxToRem(0) []
                rgba(0, 0, 0, 0.08);
            border-radius: .pxToRem(40) [];
            margin: 0 auto;
            margin-top: .pxToRem(20) [];
            .price-box {
                .base-center-y;
                left: .pxToRem(20) [];
                .sq(140);
                background: rgba(252, 219, 40, 0.1);
                border-radius: .pxToRem(30) [];
                border: .pxToRem(1) [] dashed #f8c32f;
                box-sizing: border-box;
                .price {
                    text-align: center;
                    font-size: .pxToRem(64) [];
                    font-weight: bold;
                    color: #d90209;
                    line-height: .pxToRem(80) [];
                    margin-top: .pxToRem(12) [];
                    &::before {
                        content: '¥';
                        font-size: .pxToRem(36) [];
                        font-weight: bold;
                        color: #d90209;
                        line-height: .pxToRem(40) [];
                    }
                }
                .price-desc {
                    text-align: center;
                    font-size: .pxToRem(20) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.5);
                    line-height: .pxToRem(38) [];
                }
            }
            .name {
                margin-left: .pxToRem(180) [];
                font-size: .pxToRem(28) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
                line-height: .pxToRem(52) [];
                .tip {
                    display: inline-block;
                    height: .pxToRem(42) [];
                    line-height: .pxToRem(42) [];
                    font-size: .pxToRem(22) [];
                    color: white;
                    background: #dd3021;
                    padding: 0 .pxToRem(6) [];
                    border-radius: .pxToRem(6) [];
                }
            }
            .time {
                margin-left: .pxToRem(180) [];
                font-size: .pxToRem(22) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.5);
                line-height: .pxToRem(38) [];
                margin-top: .pxToRem(8) [];
            }
            .reason {
                margin-left: .pxToRem(180) [];
                margin-top: .pxToRem(4) [];
                font-weight: 400;
                color: #d90209;
            }
            .status {
                position: absolute;
                top: .pxToRem(60) [];
                right: .pxToRem(30) [];
                .sq(44);
                background: url('~@/assets/icons/icon-unchoose.png');
                background-size: cover;
            }
            &.select {
                .status {
                    background: url('~@/assets/icons/icon-choose.png');
                    background-size: cover;
                }
            }
            &.no-select:not(.select) {
                filter: grayscale(100%);
            }
            &.no-use {
                .price-box,
                .name,
                .time,
                .status {
                    filter: grayscale(100%);
                }
            }
            &.hide-price {
                .price-box {
                    display: none;
                }
                .name,
                .time {
                    left: .pxToRem(30) [];
                }
            }
            &:first-child {
                margin-top: .pxToRem(30) [];
            }
            &:last-child {
                margin-bottom: .pxToRem(120) [];
            }
        }
    }
    .no-list {
        position: fixed;
        .base-center;
        .image {
            width: .pxToRem(240) [];
            height: .pxToRem(240) [];
        }
        .tip {
            text-align: center;
            margin-top: .pxToRem(16) [];
            font-size: .pxToRem(28) [];
            font-weight: 400;
            color: rgba(0, 0, 0, 0.5);
            line-height: .pxToRem(44) [];
        }
    }
    .footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: .pxToRem(100) [];
        line-height: .pxToRem(100) [];
        background: #ffffff;
        box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] .pxToRem(0) [] rgba(0, 0, 0, 0.08);
        .title {
            font-size: .pxToRem(30) [];
            font-weight: 400;
            color: rgba(0, 0, 0, 0.9);
            line-height: .pxToRem(40) [];
            margin-left: .pxToRem(30) [];
            .span {
                font-size: .pxToRem(36) [];
                font-weight: 600;
                color: #d90209;
                line-height: .pxToRem(36) [];
            }
        }
        .btn {
            width: .pxToRem(280) [];
            text-align: center;
            height: .pxToRem(80) [];
            line-height: .pxToRem(80) [];
            background: #fcdb28;
            border-radius: .pxToRem(40) [];
            font-size: .pxToRem(30) [];
            font-weight: 400;
            color: rgba(0, 0, 0, 0.9);
        }
    }
}
</style>

<script>
import moment from 'moment';
import { GET_AVAILABLE_COUPON_LIST, USE_MOVIE_COUPON, CANCEL_USE_MOVIE_COUPON } from 'api';
import number from '@/lib/number';
export default {
    data() {
        return {
            orderNo: '',
            seatsCount: 0,
            couponList: [],
            cardType: 0,
        };
    },
    created() {
        this.orderNo = this.$route.query.orderNo;
        this.seatsCount = this.$route.query.seatsCount;
        this.getList();
    },
    computed: {
        currentSelectCouponCount: {
            get() {
                let count = 0;
                for (let i = 0; i < this.couponList.length; i++) {
                    const item = this.couponList[i];
                    if (item.selected) {
                        count++;
                    }
                }
                return count;
            },
        },
        currentSelectSeatsCount: {
            get() {
                let count = 0;
                for (let i = 0; i < this.couponList.length; i++) {
                    const item = this.couponList[i];
                    if (item.selected) {
                        count += item.useSeatCount;
                    }
                }
                if (count == 0) {
                    this.cardType = 0;
                }
                return count;
            },
        },
        currentSelectSeatsPrice: {
            get() {
                let total = 0;
                for (let i = 0; i < this.couponList.length; i++) {
                    const item = this.couponList[i];
                    if (item.selected) {
                        total = number.operation(`${total}+${item.saveAmount}`);
                    }
                }
                return total;
            },
        },
    },
    methods: {
        getList() {
            this.$util
                .post(GET_AVAILABLE_COUPON_LIST, {
                    orderNo: this.orderNo,
                })
                .then(res => {
                    if (res.success) {
                        let list = [...res.data.available, ...res.data.unAvailable];
                        for (let i = 0; i < list.length; i++) {
                            const item = list[i];
                            item.availableEndTimeDesc = moment(item.availableEndTime).format(
                                'YYYY.M.D HH:mm'
                            );
                        }
                        this.couponList = list;
                    }
                });
        },
        clickItem(item) {
            if (item.cannotUseReason) {
                return this.$toast(item.cannotUseReason);
            }
            if (this.cardType == 0) {
                this.cardType = item.type;
            } else if (
                item.type != this.cardType &&
                this.currentSelectSeatsCount + item.useSeatCount <= this.seatsCount
            ) {
                return this.$toast('不同类型优惠券不可同时使用');
            }

            if (item.selected) {
                item.selected = !item.selected;
            } else if (this.currentSelectSeatsCount + item.useSeatCount > this.seatsCount) {
                return;
            } else {
                item.selected = !item.selected;
            }
        },
        submit() {
            if (this.currentSelectSeatsCount == 0) {
                this.$util
                    .post(CANCEL_USE_MOVIE_COUPON, {
                        orderNo: this.orderNo,
                    })
                    .then(res => {
                        if (res.success) {
                            this.$util.pageBack();
                        }
                    });
            } else {
                this.$util
                    .post(USE_MOVIE_COUPON, {
                        codes: this.couponList.filter(v => v.selected).map(v => v.code),
                        orderNo: this.orderNo,
                    })
                    .then(res => {
                        if (res.success) {
                            this.$util.pageBack();
                        }
                    });
            }
        },
    },
};
</script>
